require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-composer-private-repository-problems.json") })
        }
      }, "path---post-composer-private-repository-problems");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-composer-private-repository-problems!./.cache/json/post-composer-private-repository-problems.json
// module id = 318
// module chunks = 231608221292675